
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 58l4.99-14.96a28.5 28.5 0 1111.25 10.69L0 58z","fill":"#2cb742"}}),_c('path',{attrs:{"d":"M47.68 37.98c-1.31-2.48-6.17-5.33-6.17-5.33-1.1-.62-2.42-.7-3.04.42 0 0-1.58 1.9-1.98 2.17-1.84 1.24-3.53 1.19-5.25-.52l-3.98-3.98-3.98-3.99c-1.71-1.7-1.76-3.4-.52-5.24.28-.4 2.17-1.98 2.17-1.98 1.11-.62 1.04-1.95.42-3.04 0 0-2.85-4.86-5.33-6.17a2.73 2.73 0 00-3.2.48l-1.77 1.76C9.48 18.13 12.22 24.43 17.8 30l5.1 5.1 5.1 5.1c5.57 5.57 11.87 8.31 17.44 2.74l1.76-1.76a2.73 2.73 0 00.48-3.2z","fill":"#fff"}})])
          )
        }
      }
    